$('.Sanctuary_slider').owlCarousel({
      loop:true,
      margin:10,
      dots:false,
      nav:true,
      navText: ["<img src='https://cdn.shopify.com/s/files/1/0931/5254/3021/files/leftarr_1.png?v=1754547706'>","<img src='https://cdn.shopify.com/s/files/1/0931/5254/3021/files/rightarr.png?v=1754544996'>"],
      touchDrag:true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1
          },
          1000:{
              items:1
          }
      }
  })


  $('.residens_slider').owlCarousel({
      loop:true,
      margin:10,
      dots:true,
      nav:true,
      navText: ["<img src='https://cdn.shopify.com/s/files/1/0931/5254/3021/files/left-arrow.png?v=1754476000'>","<img src='https://cdn.shopify.com/s/files/1/0931/5254/3021/files/right-arrow_1.png?v=1754476718'>"],
      touchDrag:true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1
          },
          1000:{
              items:1
          }
      }
  })